<!-- ActionBar.vue -->
<template>
  <transition
    enter-active-class="tw-transition tw-duration-300 tw-ease-out tw-transform"
    enter-from-class="tw-opacity-0 tw-translate-y-4"
    enter-to-class="tw-opacity-100 tw-translate-y-0"
    leave-active-class="tw-transition tw-duration-200 tw-ease-in tw-transform"
    leave-from-class="tw-opacity-100 tw-translate-y-0"
    leave-to-class="tw-opacity-0 tw-translate-y-4"
  >
    <div
      v-if="!hide"
      v-bind="$attrs"
      class="tw-flex tw-shadow-lg tw-px-4 tw-bg-white tw-rounded-lg tw-h-[60px]"
      :class="positionClasses"
      :style="`width: ${width}; zIndex: ${zIndex}`"
    >
      <slot />
    </div>
  </transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    hide?: boolean
    width?: string
    zIndex?: number | string
    /**
     * When true, the bar is positioned at the bottom of the nearest positioned ancestor
     * (e.g. GraphqlDataTable in a modal). When false (default), it is fixed to the viewport.
     */
    pinToParent?: boolean
  }>(),
  {
    hide: false,
    width: '100%',
    zIndex: 9,
    pinToParent: false,
  },
)

/**
 * Bulk selection bars pass width="auto" and need horizontal centering in the viewport.
 * Pages that pass an explicit width (px / %) rely on the fixed element's static position
 * so the bar stays aligned with a centered column (e.g. payment request, job editor).
 */
const positionClasses = computed(() => {
  if (props.pinToParent) {
    return 'tw-absolute tw-bottom-1 tw-left-1/2 tw--translate-x-1/2 tw-pointer-events-auto'
  }
  if (props.width === 'auto') {
    return 'tw-fixed tw-bottom-8 tw-left-1/2 tw--translate-x-1/2'
  }
  return 'tw-fixed tw-bottom-8'
})
</script>
